// Route Paths
export const PATHS = {
  SHOWDEMO:"/showDemo",
  UPGRADE:"/upgrade/:id/:device_type/:secret_key",
  PLANS:"/upgrade/plan",
  HOME: "/home",
  LOVED_ONES:"/lovedOne",
  REPORTS:"/report",
  CARECIRCLE:"/carecircle",
  MESSAGE:"/message",
  ALERTS:"/alerts",
  SETTINGS:"/settings",
  LOGIN: "/login",
  INVITATION_HANDLER: "/invitation",
  ROOT: '/',
  SELF_DATA:"/selfData",
  CHECKOUT: "/checkout",
  PURCHASE_SUMMARY: "/summary",
  ADD_CARD_DETAILS: "/addCard"
};

//card color list
export const COLORLIST = [
  "#BEF0D8", "#FEC8AD", "#C3E3F6", "#E5D1EC",
  "#FEBCC5", "#F3F2BB", "#CBE2AC", "#B3EAEB",
  "#F1D5A0", "#F3BADA", "#B7EBB7", "#E5C7CC",
  "#F7E59D", "#C1D5B7", "#FCDBBB", "#C9EDEF",
  "#F7CEC7", "#F9D5E9", "#E7F089", "#D7E7FF",
];

//card text color list
export const TEXT_COLORLIST = [
  "#296046", "#6D442F", "#365B72", "#5E3F69",
  "#6A333A", "#605F28", "#3B5E0D", "#266162",
  "#594520", "#5C2946", "#165E16", "#6A333A",
  "#645516", "#285312", "#623B16", "#1F5A5B",
  "#542A23", "#602245", "#4D5405", "#2F425E",
];

//card interval time
export const HISTORY_INTERVAL = {
  HOURLY: "HOURLY",
  DAILY: "DAILY",
};

//card summery data ID's
export const SUMMARY_PARAM_IDS = {
  Footsteps: 4,
  Distance: 5,
  Calories: 6,
  SleepTime: 7,
  HeartRate: 9,
  Emotions: 14,
  ScreenTime: 15,
  BloodPressure: 10,
  BodyTemperature:18,
  OxygenLevel:19,
  RespiratoryRate:20,
  maxFootsteps: 24,
  maxCaloriesConsumed: 25,
  maxDistanceCovered: 26,
}


//card summery data params
export const SUMMARY_PARAM_NAMES = {
  Footsteps: "footsteps",
  Distance: "distance_covered",
  Calories: "calories_consumed",
  Emotions: "emotional_state",
  ScreenTime: "screen_interaction_time",
  wakeupTime: "first_phone_usage",
  SleepTime: "sleep_data",
  HeartRate: "heart_rate_day",
  BloodPressure: "blood_pressure",
  BodyTemperature:"body_temperature",
  OxygenLevel:"oxygen_level",
  RespiratoryRate:"respiratory_rate",
  maxFootsteps: "max_footsteps",
  maxCaloriesConsumed: "max_calories_consumed",
  maxDistanceCovered: "max_distance_covered",
};

//view data types
export const DAY_WEEK_MONTH_VIEW_TYPES = {
  DAY: 1,
  WEEK: 2,
  MONTH: 3,
};

//fellings
export const FEELING = {
  Happy: 5,
  Fine: 4,
  Ok: 3,
  DownDull: 2,
  Sad: 1,
};
export const VALIDATION_CONSTANTS = {
  mobileNumberMinLength: 10,
};

export const CHART_STYLES = {
  barWidth: 25,
  barCornerRadius: 14,
  chartHeight: 200,
  chartWidth: 300,
  domainPadding: { x: [12, 10], y: [10, 5] },
  zoomDomain: { x: [0, 8] },
  victoryLabelStyle: {
    fontSize: 8,
    fontFamily: "Montserrat-SemiBold",
    fill: "#8D959D",
  },
  victoryAxisStyle: {
    axis: { stroke: "none" }, // Removes/Hides axis line.
    grid: { stroke: "none" }, // Removes/Hides grids in background.
  },
  victoryEmotionalAxisStyle: {
    axis: { stroke: "none" }, // Removes/Hides axis line.
    //grid: { stroke: colors.chartgridColor }, // Removes/Hides grids in background.
  },
  victoryBarStepsStyle: {
    data: { fill: " #26A69A", opacity: "0.28", cursor: " pointer" }, // Set bar color.
    labels: { fontSize: 14 }, // Sets font size to label shown at top of each bar.
  },
  victoryBarDistanceStyle: {
    data: { fill: "#FE906E", opacity: "0.28", cursor: " pointer" }, // Set bar color.
    labels: { fontSize: 14 }, // Sets font size to label shown at top of each bar.
  },
  victoryBarCaloriesStyle: {
    data: { fill: "#59327C", opacity: "0.28", cursor: " pointer" }, // Set bar color.
    labels: { fontSize: 14 }, // Sets font size to label shown at top of each bar.
  },
  victoryBarScreenTimeStyle: {
    data: { fill: " #26A69A", opacity: "0.28", cursor: " pointer" }, // Set bar color.
    labels: { fontSize: 14 }, // Sets font size to label shown at top of each bar.
  },
  victoryLineStepsStyle: {
    data: { stroke: " #26A69A", strokeWidth: 4 ,cursor: " pointer"},
  },
  victoryLineDistanceStyle: {
    data: { stroke: "#FE906E", strokeWidth: 4,cursor: " pointer" },
  },
  victoryLineCaloriesStyle: {
    data: { stroke: "#59327C", strokeWidth: 4 ,cursor: " pointer"},
  },
  victoryLineEmotionalStateStyle: {
    data: { stroke: " #26A69A", strokeWidth: 4 ,cursor: " pointer"},
  },
  victoryLineScreenTimeStyle: {
    data: { stroke: " #26A69A", strokeWidth: 4 ,cursor: " pointer"},
  },
  victoryLineOxygenLevelStyle:{
    data: { stroke: "#FE906E", strokeWidth: 4,cursor: " pointer" },
  },
  victoryLineRespirationRateStyle:{
    data: { stroke: "#59327C", strokeWidth: 4 ,cursor: " pointer"},
  },
  victoryLineBodyTemperatureStyle:{
    data: { stroke: " #26A69A", strokeWidth: 4 ,cursor: " pointer"},
  },
  victoryScatterHeartRateStyle: { data: { fill: "#EC576B" } },
  victoryLineHeartRateStyle: {
    data: { stroke: "#EC576B", strokeWidth: 4 },
  },
  victoryScatterBloodPressureSystolicStyle: { data: { fill: "#EC576B" } },
  victoryLineBloodPressureSystolicStyle: {
    data: { stroke: "#EC576B", strokeWidth: 4 },
  },
  victoryScatterBloodPressureDiastolicStyle: { data: { fill: "#52AAEB" } },
  victoryLineBloodPressureDiastolicStyle: {
    data: { stroke: "#52AAEB", strokeWidth: 4 },
  },
  victoryScatterPulseStyle: { data: { fill: '#F9AF04' } },
  victoryLinePlusStyle: {
    data: { stroke: '#F9AF04', strokeWidth: 4 },
},

};
